"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

var _detectEnvironment = _interopRequireDefault(require("./detect-environment"));

var _ENV_MAP;

var ENV_MAP = (_ENV_MAP = {}, (0, _defineProperty2["default"])(_ENV_MAP, _constants.LOCAL, "https://qicm.americanexpress.com"), (0, _defineProperty2["default"])(_ENV_MAP, _constants.DEV, "https://qicm.americanexpress.com"), (0, _defineProperty2["default"])(_ENV_MAP, _constants.QA, "https://qicm.americanexpress.com"), (0, _defineProperty2["default"])(_ENV_MAP, _constants.PROD, "https://icm.aexp-static.com"), _ENV_MAP);
/**
 * Gets static host based on given hostname.
 * @returns {string}
 */

var getStaticHost = function getStaticHost(hostname) {
  return ENV_MAP[(0, _detectEnvironment["default"])(hostname)];
};

var _default = getStaticHost;
exports["default"] = _default;